import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=670e7730&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=670e7730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e7730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670e7730')) {
      api.createRecord('670e7730', component.options)
    } else {
      api.reload('670e7730', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=670e7730&scoped=true&", function () {
      api.rerender('670e7730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MaUjJODNQiOc/JS/comp/CookieBox.vue"
export default component.exports